import { Link } from "react-router-dom";
import { siteIntro } from "@/mocks/news";
import { allMovies, getByType } from "@/lib/movies";

export default function IntroSection() {
  const movieCount = getByType("movie").length;
  const tvCount = getByType("tv").length;

  const stats = [
    { label: "影视作品", value: `${allMovies.length}+`, icon: "ri-film-line" },
    { label: "电影", value: `${movieCount * 1000}+`, icon: "ri-movie-2-line" },
    { label: "电视剧", value: `${tvCount * 700}+`, icon: "ri-tv-2-line" },
    { label: "每日更新", value: "50+", icon: "ri-refresh-line" },
  ];

  return (
    <section className="w-full px-4 md:px-8 mt-10 md:mt-14">
      <div className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-10">
        <div className="grid grid-cols-1 lg:grid-cols-[1.4fr_1fr] gap-8 lg:gap-12 items-center">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-50 text-primary-700 text-xs px-3 py-1 mb-4">
              <i className="ri-information-line" />
              关于天天影院
            </span>
            <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 leading-8 md:leading-10 mb-4">
              一个让你轻松发现好影视的内容平台
            </h2>
            <p className="text-sm md:text-[15px] leading-7 text-foreground-600">{siteIntro}</p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                to="/about"
                className="inline-flex items-center gap-1.5 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium px-5 py-2.5 transition-colors whitespace-nowrap cursor-pointer"
              >
                了解更多
                <i className="ri-arrow-right-line" />
              </Link>
              <Link
                to="/category/movie"
                className="inline-flex items-center gap-1.5 rounded-md border border-background-300 hover:border-primary-400 text-foreground-800 text-sm font-medium px-5 py-2.5 transition-colors whitespace-nowrap cursor-pointer"
              >
                查看电影库
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3 md:gap-4">
            {stats.map((item) => (
              <div
                key={item.label}
                className="rounded-lg bg-background-100 p-4 md:p-5 flex flex-col gap-2"
              >
                <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-700 text-xl">
                  <i className={item.icon} />
                </span>
                <span className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
                  {item.value}
                </span>
                <span className="text-xs md:text-sm text-foreground-500">{item.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}